var exports = {
  "u4": "x936d19a0--429294--track",
  "GS": "x936d19a0--429294--fill",
};

module.exports = exports;
